// const blue1 = '#00A6ED';
const blue2 = '#3066BE';
const blue3 = '#2B5697';
const orange1 = '#FFB400';
// const orange2 = '#FFBF00';
const white1 = '#FFFFFF';
const frosted = 'rgba(255, 255, 255, 0.3)';
const logoColor = '#f69616';
// const red1 = '#F6511D';

const colors = {
  example1: {
    primary: blue3,
    secondary: '#fff',
    nav: frosted,
    accent: orange1,
    brand: logoColor
  },
  example2: {
    primary: white1,
    secondary: blue3,
    bg: blue2,
    nav: frosted,
    accent: '#333',
    brand: logoColor
  }
};

export default colors.example2;



// WEBPACK FOOTER //
// ./src/utils/colors.js